<div class="right-side p-5">
  <h2>Events List</h2>
  <div class="section">
    <form [formGroup]="form1">
      <div class="row">
        <div class="center">
          <div class="col-lg-6 col-sm-12">
            <div class="search-container">
              <div class="d-flex align-items-center flex-wrap gap-3">
                <mat-form-field
                  class="search-input flex-grow-1 mb-2"
                  appearance="outline"
                >
               <mat-label>Search</mat-label>
                  <input matInput formControlName="searchControl" />
                </mat-form-field>

                <!-- Search Button -->
                <button
                  class="btn btn-outline-secondary p-2 mx-1 mb-2"
                  type="submit"
                  (click)="
                    onSearchClick(form1.get('searchControl')?.value ?? '')
                  "
                  id="btnSearch"
                >
                  <i class="bi bi-search fs-4"></i>
                </button>

                <!-- Reset Button -->
                <button
                  class="btn btn-outline-secondary p-2 mb-2"
                  type="reset"
                  (click)="resetPage()"
                  id="btnReset"
                >
                  <i class="bi bi-arrow-clockwise fs-4"></i>
                </button>
              </div>

              <!-- Validation Message -->
              <div
                *ngIf="
                  form1.get('searchControl')?.invalid &&
                  (form1.get('searchControl')?.touched ||
                    form1.get('searchControl')?.dirty)
                "
              >
                <small
                  *ngIf="form1.get('searchControl')?.errors?.['pattern']"
                  class="text-danger"
                >
                  Invalid search term.
                </small>
              </div>
            </div>
          </div>


          <div class="table-responsive" style="max-height: 500px">
            <table
              mat-table
              [dataSource]="dataSource"
              class="table table-striped table-bordered table-hover"
              matTableResponsive
              matSortActive="EventDate"
              matSort
              matSortDirection="desc"
              matSortDisableClear
              style="font-size: smaller"
            >
              <ng-container matColumnDef="Sr.No">
                <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
                <td mat-cell *matCellDef="let el">{{ el.RowNum }}</td>
              </ng-container>
              <ng-container matColumnDef="EventId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Event Id
                </th>
                <td mat-cell *matCellDef="let el">
                  <!--{{el.EventId}}-->
                  <a
                    (click)="action(el.UniqueEventId)"
                    class="text-primary no-underline"
                    style="cursor: pointer !important"
                  >
                    {{ el.EventId }}
                  </a>
                </td>
              </ng-container>
              <ng-container matColumnDef="OrganisedBy">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Organised By
                </th>
                <td mat-cell *matCellDef="let el">{{ el.OrganisedBy }}</td>
              </ng-container>
              <ng-container matColumnDef="EventName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Event Name
                </th>
                <td mat-cell *matCellDef="let el">{{ el.EventName }}</td>
              </ng-container>
              <ng-container matColumnDef="EventDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Event Date
                </th>
                <td mat-cell *matCellDef="let el">
                  {{ el.FormatedEventDate }}
                </td>
              </ng-container>
              <ng-container matColumnDef="EventDuration">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Event Duration
                </th>
                <td mat-cell *matCellDef="let el">{{ el.EventDuration }}</td>
              </ng-container>
              <ng-container matColumnDef="VenueDetails">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Venue Details
                </th>
                <td mat-cell *matCellDef="let el">{{ el.VenueDetails }}</td>
              </ng-container>
              <ng-container matColumnDef="Intervention">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Intervention
                </th>
                <td mat-cell *matCellDef="let el">{{ el.Intervention }}</td>
              </ng-container>
              <ng-container matColumnDef="Component">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Component
                </th>
                <td mat-cell *matCellDef="let el">{{ el.Component }}</td>
              </ng-container>
              <ng-container matColumnDef="NumberofParticipants">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  No. of Participants
                </th>
                <td mat-cell *matCellDef="let el">
                  {{ el.NumberofParticipants }}
                </td>
              </ng-container>
              <ng-container matColumnDef="FocusSector">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Focus Sector
                </th>
                <td mat-cell *matCellDef="let el">{{ el.FocusSector }}</td>
              </ng-container>
              <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Status
                </th>
                <td mat-cell *matCellDef="let el">{{ el.Status }}</td>
              </ng-container>

              <!-- Event URL column -->
              <ng-container matColumnDef="EventURL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Event&nbsp;URL
                </th>

                <td mat-cell *matCellDef="let el" class="text-truncate">
                  <!-- If el.EventURL might be null/empty, guard with *ngIf -->
                  <a
                    *ngIf="el.EventURL"
                    [href]="el.EventURL"
                    target="_blank"
                    rel="noopener"
                    class="text-decoration-none word-break"
                  >
                    {{ el.EventURL }}
                  </a>

                  <!-- Optional fallback when URL is missing -->
                  <span *ngIf="!el.EventURL" class="text-muted">—</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="Download">
                <th mat-header-cell *matHeaderCellDef>Download</th>
                <td mat-cell *matCellDef="let el">
                  <a
                    class="text-decoration-none btn btn-warning btn-sm"
                    *ngIf="el.DocumentPath"
                    (click)="
                      onDownload(el.DocumentPath, el.DocumentName);
                      $event.preventDefault()
                    "
                    style="text-decoration: underline; cursor: pointer"
                  >
                    <i class="bi bi-download"></i> Download
                  </a>
                </td>
              </ng-container>

              <ng-container matColumnDef="viewFeedback">
                <th mat-header-cell *matHeaderCellDef>View Feedback</th>
                <td mat-cell *matCellDef="let el" class="text-center">
                  <button
                    class="btn btn-primary btn-sm"
                    (click)="onViewFeedback(el.UniqueEventId)"
                    *ngIf="el.SubmittedFeedback > 0; else showFeebackMsg"
                  >
                    <i class="bi bi-eye"></i><br />View Feedback
                  </button>
                  <ng-template #showFeebackMsg>
                    <span style="color: red; font-weight: bold">
                      No Feedback Available
                    </span>
                  </ng-template>
                </td>
              </ng-container>

              <!-- Attendance Marked column -->
              <ng-container matColumnDef="AttendanceMarked">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Attendance Marked
                </th>
                <td mat-cell *matCellDef="let el">
                  <span
                    [ngClass]="{
                      'text-success': el.AttendanceMarked === 'Yes',
                      'text-danger': el.AttendanceMarked === 'No',
                    }"
                  >
                    {{ el.AttendanceMarked }}
                  </span>
                </td>
              </ng-container>

              <!-- Document Uploaded column -->
              <ng-container matColumnDef="DocumentUploaded">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Document Uploaded
                </th>
                <td mat-cell *matCellDef="let el">
                  <span
                    [ngClass]="{
                      'text-success': el.DocumentUploaded === 'Yes',
                      'text-danger': el.DocumentUploaded === 'No',
                    }"
                  >
                    {{ el.DocumentUploaded }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef>Action</th>

<td mat-cell *matCellDef="let el">

  <div class="table-actions">

    <!-- 🔄 Change Attendance -->
    <button
      mat-stroked-button
      color="primary"
      class="action-btn"
      (click)="onChangeAttendance(el)">
   
      Update Attendance
    </button>

    <!-- 📊 Audit -->
    <button
      mat-stroked-button
      color="accent"
      class="action-btn"
      (click)="openAudit(el)">

      Audit
    </button>

  </div>

</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

              Row shown when there is no matching data.
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                  No data matching the filter
                </td>
              </tr>
            </table>
          </div>
          <mat-paginator
            #paginator
            class="demo-paginator"
            (page)="onPageChange($event)"
            [length]="length"
            [pageSize]="pageSize"
            [showFirstLastButtons]="showFirstLastButtons"
            [pageSizeOptions]="pageSizeOptions"
            [hidePageSize]="hidePageSize"
            [pageIndex]="pageIndex"
            aria-label="Select page"
          >
          </mat-paginator>
        </div>
      </div>
    </form>
  </div>
</div>


